// @flow
import { getFirstElement } from 'clark-utils';

import {
  getPayerAuthenticatedSuccess,
  getNewPayerAuthenticatedSuccess,
  getPayerSuccess,
  incrementPayerPage,
  toggleCreditCardForm,
} from 'actions/payer';

import { getCorrectUserPaymentMethod } from 'utils/payment-method';

const initialState = {
  page: 0,
  data: {},
  charge: {
    attributes: {},
  },
  clients: {},
  tutors: {},
  business: {
    attributes: {},
  },
};

const payerReducer = (state: any = initialState, action: any) => {
  const actions = {
    [getPayerAuthenticatedSuccess.toString()]: () => {
      const { businesses, paymentMethods, charges, clients, tutors, payer: data } = action.payload;

      const business = businesses && getFirstElement(businesses);
      const client = clients && getFirstElement(clients);
      const tutor = tutors && getFirstElement(tutors);
      const charge = charges && getFirstElement(charges);
      const {
        attributes: { paymentMethodType },
      } = charge;

      const paymentMethod = getCorrectUserPaymentMethod(data, paymentMethods, paymentMethodType);

      return {
        ...state,
        data,
        business,
        paymentMethod,
        charge,
        client,
        tutor,
      };
    },
    [getNewPayerAuthenticatedSuccess.toString()]: () => {
      const { businesses, paymentMethods, payer: data } = action.payload;

      const business = businesses && getFirstElement(businesses);

      const paymentMethod = getCorrectUserPaymentMethod(data, paymentMethods, 'creditCard');

      return {
        ...state,
        data,
        business,
        paymentMethod,
      };
    },
    [getPayerSuccess.toString()]: () => ({
      ...state,
      data: action.payload.payer,
    }),
    [incrementPayerPage.toString()]: () => ({
      ...state,
      page: state.page + 1,
    }),
    [toggleCreditCardForm.toString()]: () => ({
      ...state,
      showNewCreditCardForm: !state.showNewCreditCardForm,
    }),
    DEFAULT: () => state,
  };

  return (actions[action.type] || actions.DEFAULT)();
};

export default payerReducer;



// WEBPACK FOOTER //
// ./src/reducers/payer.js